import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import {
    InstitutionCreateDepartmentBreadcrumbs,
    InstitutionDepartmentBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as DepartmentActions from "../../../actions/department";
import * as InstitutionActions from "../../../actions/institution";
import * as NavigationActions from "../../../actions/navigation";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    SelectFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import { Link } from "../../../components/routing/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import { PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { InstitutionSubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import {
    IDepartmentReduxFormState,
    initialDepartmentState,
} from "../../../reducers/reactReduxForms/department";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./InstitutionDepartmentEditPage.scss";

interface IInstitutionDepartmentEditPageParams {
    institutionId: number;
    departmentId: number;
}

interface IInstitutionDepartmentEditPageProps
    extends IRouterProps<IInstitutionDepartmentEditPageParams> {
    form: Dtos.Department & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IDepartmentReduxFormState;

    institutionId: number;
    departmentId: number;

    // From state
    department: Dtos.Department;
    institution: Dtos.Institution;
    lookups: Dtos.Lookup[];

    loadingInstitution: boolean;
    loadInstitutionSuccess: boolean;
    loadInstitutionFailure: boolean;
    loadInstitutionErrorCode: string;

    loadingDepartment: boolean;
    loadDepartmentSuccess: boolean;
    loadDepartmentFailure: boolean;
    loadDepartmentErrorCode: string;

    savingDepartment: boolean;
    saveDepartmentSuccess: boolean;
    saveDepartmentFailure: boolean;

    creatingDepartment: boolean;
    createDepartmentSuccess: boolean;
    createDepartmentFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IInstitutionDepartmentEditPageActions extends IRouterActions {
    clearDepartment: DepartmentActions.IDepartmentClearActionCreator;
    loadDepartment: DepartmentActions.IDepartmentLoadByIdActionCreator;
    saveDepartment: DepartmentActions.IDepartmentSaveActionCreator;
    createDepartment: DepartmentActions.IDepartmentCreateActionCreator;

    clearInstitution: InstitutionActions.IInstitutionClearActionCreator;
    loadInstitution: InstitutionActions.IInstitutionLoadByIdActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type InstitutionDepartmentEditPageProps = IInstitutionDepartmentEditPageProps &
    IInstitutionDepartmentEditPageActions;

const reduxFormName: string = "reduxForms.department";

class InstitutionDepartmentEditPage extends React.PureComponent<
    InstitutionDepartmentEditPageProps,
    any
> {
    constructor(props: InstitutionDepartmentEditPageProps) {
        super(props);

        this.clearDepartment = this.clearDepartment.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadDepartment,
            createDepartment,
            departmentId,
            institutionId,
            loadInstitution,
            setDrawerItems,
            setBreadcrumbs,
            permissions
        } = this.props;
        

        setDrawerItems(InstitutionSubMenu(institutionId, permissions));
        if (departmentId) {
            setBreadcrumbs(
                InstitutionDepartmentBreadcrumbs(institutionId, departmentId)
            );
            loadDepartment(departmentId);
        } else if (!departmentId) {
            setBreadcrumbs(
                InstitutionCreateDepartmentBreadcrumbs(institutionId)
            );
            createDepartment(institutionId);
        }
        loadInstitution(institutionId);
    }

    componentWillReceiveProps(_nextProps: InstitutionDepartmentEditPageProps) {}

    componentDidUpdate(
        prevProps: InstitutionDepartmentEditPageProps,
        _prevState
    ) {
        const {
            form,
            institutionId,
            departmentId,
            department,
            loadDepartment,
            loadInstitution,
            loadingDepartment,
            loadDepartmentSuccess,
            savingDepartment,
            saveDepartmentSuccess,
            createDepartment,
            validationFailures,
            creatingDepartment,
            createDepartmentSuccess,
            navigate,
            institution,
            permissions,
            setDrawerItems,
            setBreadcrumbs,
            loadDepartmentFailure,
            loadInstitutionFailure,
            loadDepartmentErrorCode,
            loadInstitutionErrorCode,
        } = this.props;

        if (loadDepartmentFailure) {
            navigate(`/error/${loadDepartmentErrorCode}`);
        }
        if (loadInstitutionFailure) {
            navigate(`/error/${loadInstitutionErrorCode}`);
        }

        if (
            institutionId &&
            institution?.name &&
            departmentId &&
            department?.name
        ) {
            setDrawerItems(InstitutionSubMenu(institutionId, permissions));
            setBreadcrumbs(
                InstitutionDepartmentBreadcrumbs(
                    institutionId,
                    departmentId,
                    institution.name,
                    department.name
                )
            );
        } else if (!departmentId) {
            setBreadcrumbs(
                InstitutionCreateDepartmentBreadcrumbs(
                    institutionId,
                    institution?.name
                )
            );
        }

        if (institutionId && prevProps.institutionId != institutionId) {
            loadInstitution(institutionId);
        }

        if (departmentId && prevProps.departmentId != departmentId) {
            loadDepartment(departmentId);
        } else if (!departmentId && prevProps.departmentId) {
            createDepartment(institutionId);
        }

        if (!loadingDepartment && prevProps.loadingDepartment) {
            if (loadDepartmentSuccess) {
                this.loadForm();
            }
        }

        if (!savingDepartment && prevProps.savingDepartment) {
            if (saveDepartmentSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate("/institutions/" + institutionId + "/departments");
                } else if (
                    !form.saveAndReturn &&
                    departmentId &&
                    departmentId > 0
                ) {
                    this.loadForm();
                } else if (
                    !form.saveAndReturn &&
                    !departmentId &&
                    department &&
                    department.id > 0
                ) {
                    navigate(
                        "/institutions/" +
                            institutionId +
                            "/departments/" +
                            department.id
                    );
                    this.loadForm();
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingDepartment && prevProps.creatingDepartment) {
            if (createDepartmentSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(_nextProps: InstitutionDepartmentEditPageProps) {}

    componentWillUnmount() {
        const { resetForm, loadForm } = this.props;

        this.clearDepartment();
        loadForm(reduxFormName, initialDepartmentState);
        resetForm(reduxFormName);
    }

    clearDepartment() {
        this.props.clearDepartment();
        this.props.clearInstitution();
    }

    showDepartment(): boolean {
        const { loadingInstitution, loadingDepartment, loadDepartmentSuccess } =
            this.props;

        if (
            !loadingInstitution &&
            !loadingDepartment &&
            loadDepartmentSuccess
        ) {
            return true;
        }

        return false;
    }

    render() {
        const { loadingInstitution, loadingDepartment } = this.props;

        return (
            <RestrictedLayout
                permission={Dtos.Permission.InstitutionDepartmentView}
                loading={loadingInstitution || loadingDepartment}
            >
                {this.renderContent()}
            </RestrictedLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingDepartment,
            institutionId,
            departmentId,
            permissions,
        } = this.props;

        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.InstitutionDepartmentUpdate,
                Dtos.Permission.InstitutionDepartmentCreate
            );
        const canCreatePersonnelRole: boolean =
            AuthenticationHelper.hasPermission(
                permissions,
                Dtos.Permission.InstitutionPersonnelCreate,
                null,
                institutionId
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingDepartment ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);
        const personnelRoles =
            form && form.personnelRoles ? form.personnelRoles : [];

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            name: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: "col-form-label col-sm-3",
                fieldClassName: "col-sm-9 generic-form-field",
            },
            addressGroup: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    physicalAddressHeading: {
                        type: RegistrationComponent.RegistrationElement,
                        size: 1,
                        component: (
                            <div className="mt-3">
                                <h5>Physical Address</h5>
                            </div>
                        ),
                    },
                    address1: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1,
                    },
                    address2: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1,
                    },
                    suburb: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                    },
                    postcode: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                    },
                    stateId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(
                                findLookup("Department", "StateId", lookups),
                                form.stateId
                            ),
                        },
                        size: 2,
                        changeAction: (model, value, form, parentModel) => {
                            changeForm(model, value);
                            changeForm(
                                reduxFormName + parentModel + ".state",
                                null
                            );
                            if (value == null || value != 10) {
                                changeForm(
                                    reduxFormName + parentModel + ".stateOther",
                                    null
                                );
                            }
                        },
                    },
                    stateOther: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled:
                            formDisabled ||
                            (form && form.stateId == null) ||
                            (form && form.stateId != 10),
                        size: 2,
                    },
                    countryId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(
                                findLookup("Department", "CountryId", lookups),
                                form.countryId
                            ),
                        },
                        size: 2,
                    },
                },
            },
            mailingAddressGroup: {
                type: RegistrationComponent.RegistrationGroupFormControls,
                components: {
                    physicalAddressHeading: {
                        type: RegistrationComponent.RegistrationElement,
                        size: 1,
                        component: (
                            <div className="mt-3">
                                <h5>Mailing Address</h5>
                            </div>
                        ),
                    },
                    mailAddress1: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1,
                    },
                    mailAddress2: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 1,
                    },
                    mailSuburb: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                    },
                    mailPostcode: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled: formDisabled,
                        size: 2,
                    },
                    mailStateId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(
                                findLookup(
                                    "Department",
                                    "MailStateId",
                                    lookups
                                ),
                                form.mailStateId
                            ),
                        },
                        size: 2,
                        changeAction: (model, value, form, parentModel) => {
                            changeForm(model, value);
                            changeForm(
                                reduxFormName + parentModel + ".mailState",
                                null
                            );
                            if (value == null || value != 10) {
                                changeForm(
                                    reduxFormName +
                                        parentModel +
                                        ".mailStateOther",
                                    null
                                );
                            }
                        },
                    },
                    mailStateOther: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextFormInput,
                        inputDisabled:
                            formDisabled ||
                            (form && form.mailStateId == null) ||
                            (form && form.mailStateId != 10),
                        size: 2,
                    },
                    mailCountryId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: formDisabled,
                        inputProps: {
                            options: generateOptionsFromLookup(
                                findLookup(
                                    "Department",
                                    "MailCountryId",
                                    lookups
                                ),
                                form.mailCountryId
                            ),
                        },
                        size: 2,
                    },
                },
            },
            phone: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: "col-form-label col-sm-3",
                fieldClassName: "col-sm-9 generic-form-field",
            },
            fax: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
                labelClassName: "col-form-label col-sm-3",
                fieldClassName: "col-sm-9 generic-form-field",
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active",
                },
                inputLabel: " ",
                labelClassName: "col-form-label col-sm-3",
                fieldClassName: "col-sm-9 generic-form-field",
            },
            personnelRolesHeading: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <div className="border-0 d-flex pt-4 pl-0">
                        <h5>Department Roles</h5>
                    </div>
                ),
            },
            personnelRoles: {
                type: RegistrationComponent.RegistrationElement,
                component:
                    !personnelRoles || personnelRoles.length == 0 ? (
                        <>
                            <div className="card card-shadow p-3">
                                <div className="alert alert-info d-flex mb-0">
                                    <div className="mr-2">
                                        <FontAwesomeIcon
                                            icon={
                                                FontAwesomeIcons.Solid
                                                    .INFO_SQUARE
                                            }
                                            fixedWidth
                                        />
                                    </div>
                                    <span>
                                        There are currently no department roles
                                        to view.
                                    </span>
                                </div>
                                <div className="mt-3 mb-3">
                                    {canCreatePersonnelRole && departmentId && (
                                        <Link
                                            className={
                                                "btn btn-secondary btn-sm"
                                            }
                                            url={
                                                "/institutions/" +
                                                institutionId +
                                                "/departments/" +
                                                departmentId +
                                                "/personnel/create"
                                            }
                                        >
                                            Add Role
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="table-wrapper">
                            <ReactTable
                                data={personnelRoles}
                                pageSizeOptions={PAGE_SIZE_OPTIONS}
                                defaultPageSize={personnelRoles.length}
                                pageSize={personnelRoles.length}
                                showPagination={false}
                                className="-striped -highlight -clickable"
                                noDataText="There are currently no roles to display"
                                resizable={false}
                                onPageSizeChange={(_val) => {}}
                                getTdProps={(
                                    state,
                                    rowInfo: RowInfo,
                                    _column,
                                    _instance
                                ) => {
                                    return {
                                        onClick: (e, handleOriginal) => {
                                            const url: string =
                                                "/personnel/" +
                                                rowInfo.original.personnelId +
                                                "/details";
                                            this.props.navigate(url);

                                            if (handleOriginal) {
                                                handleOriginal();
                                            }
                                        },
                                        style: {
                                            color:
                                                rowInfo &&
                                                rowInfo.original &&
                                                rowInfo.original.active
                                                    ? "#212529"
                                                    : "#9e9e9e",
                                        },
                                    };
                                }}
                                defaultSorted={[
                                    {
                                        id: "personnelDisplay",
                                        desc: false,
                                    },
                                ]}
                                columns={[
                                    {
                                        id: "id",
                                        Header: " ",
                                        accessor: "id",
                                        maxWidth: 50,
                                        Cell: (_props) => (
                                            <FontAwesomeIcon
                                                size="lg"
                                                icon={
                                                    FontAwesomeIcons.Light.USER
                                                }
                                                fixedWidth
                                            />
                                        ),
                                    },
                                    {
                                        id: "personnelDisplay",
                                        Header: "Name",
                                        accessor: "personnelDisplay",
                                    },
                                    {
                                        id: "roleDisplay",
                                        Header: "Role",
                                        accessor: "roleDisplay",
                                    },
                                    {
                                        id: "trialDisplay",
                                        Header: "Trial",
                                        accessor: "trialDisplay",
                                    },
                                    {
                                        id: "email",
                                        Header: "Email",
                                        accessor: "emailDisplay",
                                    },
                                    {
                                        id: "phone",
                                        Header: "Phone",
                                        accessor: "personnel.phone",
                                    },
                                ]}
                            />
                            <div className="mt-3 mb-3">
                                {canCreatePersonnelRole && departmentId && (
                                    <Link
                                        className={"btn btn-secondary btn-sm"}
                                        url={
                                            "/institutions/" +
                                            institutionId +
                                            "/departments/" +
                                            departmentId +
                                            "/personnel/create"
                                        }
                                    >
                                        Add Role
                                    </Link>
                                )}
                            </div>
                        </div>
                    ),
            },
        };

        return (
            <div
                className="container"
                style={{
                    maxWidth: "1600px",
                }}
            >
                <h1>Institution Department</h1>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    <div className="card px-4">
                        {renderFormControls(
                            form,
                            "department",
                            formComponents,
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )}
                    </div>
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderErrorAlert(): any {
        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return (
            <div>The form has been saved successfully</div>
        );
    }

    handleOnSubmit(data: Dtos.Department) {
        const { saveDepartment } = this.props;

        if (data) {
            let changes: Dtos.Department = {} as Dtos.Department;
            saveDepartment(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.Department) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onCancel() {
        const { institutionId, navigate } = this.props;

        navigate(`/institutions/${institutionId}/departments`);
    }

    loadForm() {
        const { loadForm, department } = this.props;

        let extraData: Dtos.Department = {} as Dtos.Department;

        loadForm(reduxFormName, Object.assign({ ...department }, extraData));
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: InstitutionDepartmentEditPageProps
): IInstitutionDepartmentEditPageProps => {
    let department: Dtos.Department | undefined = !(
        state.departments.formData instanceof Array
    )
        ? state.departments.formData
        : undefined;
    let institution: Dtos.Institution | undefined = !(
        state.institutions.formData instanceof Array
    )
        ? state.institutions.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        match: ownProps.match,
        institutionId: ownProps.match
            ? ownProps.match.params.institutionId
            : undefined!,
        departmentId:
            ownProps.match &&
            ownProps.match.params.departmentId.toString() != "create"
                ? ownProps.match.params.departmentId
                : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        department: department!,

        institution: institution!,

        loadingDepartment:
            state.departments.loadState &&
            state.departments.loadState.status == RequestState.Pending,
        loadDepartmentSuccess:
            state.departments.loadState &&
            state.departments.loadState.status == RequestState.Success,
        loadDepartmentFailure:
            state.departments.loadState &&
            state.departments.loadState.status == RequestState.Failure,
        loadDepartmentErrorCode: state.departments.loadState.errorCode,

        savingDepartment:
            state.departments.saveState &&
            state.departments.saveState.status == RequestState.Pending,
        saveDepartmentSuccess:
            state.departments.saveState &&
            state.departments.saveState.status == RequestState.Success,
        saveDepartmentFailure:
            state.departments.saveState &&
            state.departments.saveState.status == RequestState.Failure,

        creatingDepartment:
            state.departments.createState &&
            state.departments.createState.status == RequestState.Pending,
        createDepartmentSuccess:
            state.departments.createState &&
            state.departments.createState.status == RequestState.Success,
        createDepartmentFailure:
            state.departments.createState &&
            state.departments.createState.status == RequestState.Failure,

        loadingInstitution:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Pending,
        loadInstitutionSuccess:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Success,
        loadInstitutionFailure:
            state.institutions.loadState &&
            state.institutions.loadState.status == RequestState.Failure,
        loadInstitutionErrorCode: state.institutions.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,
        lookups: state.departments.lookups,

        form: state.reduxForms.department,
        formState: state.departments.formState,
        formProperties: state.departments.formProperties,

        reduxFormState: state.reduxForms.formState.department,
        validationFailures: department
            ? state.departments.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: InstitutionDepartmentEditPageProps
): IInstitutionDepartmentEditPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadDepartment: bindActionCreators(
            DepartmentActions.LoadDepartmentById,
            dispatch
        ),
        clearDepartment: bindActionCreators(DepartmentActions.Clear, dispatch),
        createDepartment: bindActionCreators(
            DepartmentActions.CreateDepartment,
            dispatch
        ),
        saveDepartment: bindActionCreators(
            DepartmentActions.SaveDepartment,
            dispatch
        ),

        loadInstitution: bindActionCreators(
            InstitutionActions.LoadInstitutionById,
            dispatch
        ),
        clearInstitution: bindActionCreators(
            InstitutionActions.Clear,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    IInstitutionDepartmentEditPageParams,
    InstitutionDepartmentEditPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        InstitutionDepartmentEditPage
    ) as unknown as ComponentType<InstitutionDepartmentEditPageProps>
) as ComponentType<any>;
